var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Empty_Icon",
    "data-name": "Empty Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 96,
    height: 96,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 96,
    height: 96,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(8.005 4.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M52.025,27a4,4,0,0,0-4-4H16a4,4,0,0,0,0,8.005h32.02A4,4,0,0,0,52.025,27Z",
    transform: "translate(4.01 19.027)",
    fill: "#c7c3b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M16,31a4,4,0,0,0,0,8.005h16.01a4,4,0,0,0,0-8.005Z",
    transform: "translate(4.01 27.037)",
    fill: "#c7c3b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M68.041,80.048H12.005V12.005H32.018a4,4,0,0,0,4-4h0a4,4,0,0,0-4-4H8A4,4,0,0,0,4,8V84.051a4,4,0,0,0,4,4H72.043a4,4,0,0,0,4-4V52.03a4,4,0,0,0-4-4h0a4,4,0,0,0-4,4Z",
    transform: "translate(-4 0.003)",
    fill: "#c7c3b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M78.842,43.226,68.636,33.02a19.412,19.412,0,0,0,3.4-11.007,20.013,20.013,0,1,0-40.025,0,19.813,19.813,0,0,0,1,6H16a4,4,0,0,0,0,8.005H37.816a20.213,20.213,0,0,0,14.209,6,19.412,19.412,0,0,0,11.007-3.4L73.239,48.83a3.964,3.964,0,1,0,5.6-5.6ZM40.018,22.013A12.008,12.008,0,1,1,52.025,34.02,12.008,12.008,0,0,1,40.018,22.013Z",
    transform: "translate(4.01 -2)",
    fill: "#c7c3b4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyIcon);
export default __webpack_public_path__ + "static/media/empty-icon.ef444d4050abcaa2ca5ffad52f880e13.svg";
export { ForwardRef as ReactComponent };